import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import { DimensionModel } from "../../../../Models/DimensionModel";
import { RequestDecoratorModel } from "../../../../Types/requestDecoratorModel";
import { UI_CONSTANTS } from "../../../../Constants/constants";

export const decoratePayloadAndEndPoint = (
  editableData: any,
  selectedMenu: string
): RequestDecoratorModel => {
  //In case if any service required additional header, it need to reassign in respective block
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  let data: RequestDecoratorModel = {
    endPoint: "",
    headers: null,
    payload: null,
    method: "",
  };

  type SourceOfChange =
    | "Attribute"
    | "Query"
    | "MeasurementsClothing"
    | "Hierarchy"
    | "Measurements"
    | "";
  let sourceOfChange: SourceOfChange = "";

  switch (selectedMenu) {
    case "Query":
      sourceOfChange = "Query";
      break;
    case "Attributes":
      sourceOfChange = "Attribute";
      break;
    case "Measurements-Clothing":
      sourceOfChange = "MeasurementsClothing";
      break;
    case "Hierarchy":
      sourceOfChange = "Hierarchy";
      break;
    case "Measurements":
      sourceOfChange = "Measurements";
      break;
    default:
      break;
  }

  let payLoad = {
    FamilyGroup: editableData?.FamilyGroup,
    ProductType: editableData?.ProductType,
    Ti: editableData?.Ti,
    Hi: editableData?.Hi,
    PackSize: editableData?.PackSize,
    ProductGroup: editableData?.ProductGroup,
    BreakPack: editableData?.BreakPackIndicator,
    EAN: editableData?.EAN,
    OuterWeight: editableData?.OuterWeight,
    OuterLength: editableData?.OuterLength,
    OuterWidth: editableData?.OuterWidth,
    OuterHeight: editableData?.OuterHeight,
    OldFamilyGroup: editableData?.OldFamilyGroup,
    Hazardous: editableData?.Hazardous,
    HazardousCode: editableData?.HazardousCode,
    Conveyable: editableData?.Conveyable,
    Lifecycle: editableData?.Lifecycle,
    NestedItem: editableData?.NestedItem,
    NestedIncrement: editableData?.NestedIncrement,
    MLOI: editableData?.MLOI,
    MLOR: editableData?.MLOR,
    Uglies: editableData?.Uglies,
    TwoPersonLift: editableData?.TwoPersonLift,
    MuType: editableData?.MuType,
    AutomationAdaptoSystem: editableData?.AutomationAdaptoSystem,
    AutomationToteFill: editableData?.AutomationToteFill,
    AutomationMinTotes: editableData?.AutomationMinTotes,
    HighRisk: editableData?.HighRisk,
    StrapTotes: editableData?.StrapTotes,
    ExpiryDateRequired: editableData?.ExpiryDateRequired,
    PickPack: editableData?.PickPack,
    DimensionData: {
      Manual: editableData.Manual,
      HasWarnings: editableData.HasWarnings,
      BreakPackIndicator: editableData.BreakPackIndicator,
      OuterDimensions: {
        Height: editableData.OuterDimensions.Height
          ? editableData.OuterDimensions.Height
          : null,
        HeightUOM: editableData.OuterDimensions.Height
          ? editableData?.OuterDimensions.HeightUOM
          : null,
        Width: editableData.OuterDimensions.Width
          ? editableData.OuterDimensions.Width
          : null,
        WidthUOM: editableData.OuterDimensions.Width
          ? editableData.OuterDimensions.WidthUOM
          : null,
        Length: editableData.OuterDimensions.Length
          ? editableData.OuterDimensions.Length
          : null,
        LengthUOM: editableData.OuterDimensions.Length
          ? editableData.OuterDimensions.LengthUOM
          : null,
        Weight: editableData.OuterDimensions.Weight
          ? editableData.OuterDimensions.Weight
          : null,
        WeightUOM: editableData.OuterDimensions.Weight
          ? editableData.OuterDimensions.WeightUOM
          : null,
        Ti: editableData?.OuterDimensions.Ti
          ? editableData?.OuterDimensions.Ti
          : null,
        Hi: editableData?.OuterDimensions.Hi
          ? editableData?.OuterDimensions.Hi
          : null,
        BreakPackQty: editableData?.OuterDimensions.BreakPackQty
          ? editableData?.OuterDimensions.BreakPackQty
          : null,
      },
      InnerDimensions: {
        Height: editableData.InnerDimensions.Height
          ? editableData.InnerDimensions.Height
          : null,
        HeightUOM: editableData.InnerDimensions.Height
          ? editableData?.InnerDimensions.HeightUOM
          : null,
        Width: editableData.InnerDimensions.Width
          ? editableData.InnerDimensions.Width
          : null,
        WidthUOM: editableData.InnerDimensions.Width
          ? editableData.InnerDimensions.WidthUOM
          : null,
        Length: editableData.InnerDimensions.Length
          ? editableData.InnerDimensions.Length
          : null,
        LengthUOM: editableData.InnerDimensions.Length
          ? editableData.InnerDimensions.LengthUOM
          : null,
        Weight: editableData.InnerDimensions.Weight
          ? editableData.InnerDimensions.Weight
          : null,
        WeightUOM: editableData.InnerDimensions.Weight
          ? editableData.InnerDimensions.WeightUOM
          : null,
        Ti: editableData?.InnerDimensions.Ti
          ? editableData?.InnerDimensions.Ti
          : null,
        Hi: editableData?.InnerDimensions.Hi
          ? editableData?.InnerDimensions.Hi
          : null,
      },
    },
    Source: UI_CONSTANTS.LDMUI,
    SourceOfChange: sourceOfChange,
  };

  data = {
    payload: payLoad,
    headers: headers,
    endPoint: endpoints.updateProduct(editableData?.Id),
    method: "PATCH",
  };
  return data;
};
